import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Finché un menu è in analisi (in sottofondo sul server) ricarica l'elenco e avvisa alla fine
export const useMenuInAnalisi = (menus, setMenus, getHeaders) => {
  const stati = useRef({});
  const headers = useRef(getHeaders);
  headers.current = getHeaders;
  const inCorso = menus.some((m) => m.status === 'parsing');

  useEffect(() => {
    stati.current = Object.fromEntries(menus.map((m) => [m.id, m.status]));
  }, [menus]);

  useEffect(() => {
    if (!inCorso) return undefined;
    const id = setInterval(async () => {
      try {
        const { data } = await axios.get(`${API}/menus`, { headers: headers.current() });
        data.forEach((m) => {
          if (stati.current[m.id] !== 'parsing') return;
          if (m.status === 'parsed') toast.success(m.parse_message || 'Menu analizzato');
          if (m.status === 'error') toast.error(m.parse_error || 'Errore nell\'analisi del menu');
        });
        setMenus(data);
      } catch (e) {
        console.error('Stato analisi menu non disponibile', e);
      }
    }, 4000);
    return () => clearInterval(id);
  }, [inCorso, setMenus]);
};

export const ProgressoAnalisi = ({ menu }) => {
  const p = menu.progresso || {};
  const perc = p.totale ? Math.round((p.fatti / p.totale) * 100) : 0;
  const testo = p.fase === 'ricette'
    ? `Preparo le ricette senza doppioni… ${p.fatti}/${p.totale}`
    : `Leggo le pagine del menu… ${p.fatti || 0}/${p.totale || '…'}`;
  return (
    <div className="mt-3 rounded-lg border border-blue-200 bg-blue-50 p-3" data-testid={`menu-progresso-${menu.id}`}>
      <p className="flex items-center gap-2 text-sm font-medium text-blue-800">
        <RefreshCw className="h-4 w-4 animate-spin" /> {testo}
      </p>
      <div className="mt-2 h-1.5 rounded-full bg-blue-100 overflow-hidden">
        <div className="h-full bg-blue-500 transition-[width] duration-500" style={{ width: `${perc}%` }} />
      </div>
      <p className="mt-1 text-xs text-blue-700/80">Puoi lasciare la pagina: l'analisi continua da sola.</p>
    </div>
  );
};
